import { render } from "./SpotName.vue?vue&type=template&id=2d1d0e9f"
import script from "./SpotName.vue?vue&type=script&lang=js"
export * from "./SpotName.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__